/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestaccept1Inputs */

const en_requestaccept1 = /** @type {(inputs: Requestaccept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const de_requestaccept1 = /** @type {(inputs: Requestaccept1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annehmen`)
};

/**
* | output |
* | --- |
* | "Accept" |
*
* @param {Requestaccept1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestaccept1 = /** @type {((inputs?: Requestaccept1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestaccept1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestaccept1(inputs)
	return de_requestaccept1(inputs)
});
export { requestaccept1 as "requestAccept" }